export const SET_SOCIAL_SECURITY_TAXES = "SET_SOCIAL_SECURITY_TAXES"
export const SET_MEDICARE_TAXES = "SET_MEDICARE_TAXES"
export const SET_GROWTH_RATE = "SET_GROWTH_RATE"
export const SET_STATE_TAXES = "SET_STATE_TAXES"
export const SET_FEDERAL_TAXES = "SET_FEDERAL_TAXES"